import api from ".";

class ToolsAPI {
    static all() {
        return api.get("/tools");
    }
}

export default ToolsAPI;
